import { cn } from '@utima/ui';
import { Lock } from 'lucide-react';
import { memo } from 'react';

import { LockedFeatureTooltip } from './LockedFeatureTooltip';

export type LockedFeatureIconProps = {
  locked: boolean;
  className?: string;
  message?: string;
};

export const LockedFeatureIcon = memo(function LockedFeatureIcon({
  locked,
  className,
  message,
}: LockedFeatureIconProps) {
  if (!locked) {
    return null;
  }

  return (
    <LockedFeatureTooltip locked message={message}>
      <span className='inline-flex'>
        <Lock
          className={cn('size-3 shrink-0 text-muted-fg', className)}
          aria-hidden
        />
      </span>
    </LockedFeatureTooltip>
  );
});
